<div class="list-page-container">
  <div class="content-container">
    <div class="page-header-container">
      <app-page-header [title]="'Demo Log In'"></app-page-header>
    </div>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="data-container">
        <div class="text-input">
          <div class="row-input">
            <dxo-text-input
              [label]="'User name'"
              [maxlength]="80"
              formControlName="username"
              [dxoDataset]="[{ selector: 'input', data: { e2e: 'userlogin-name-input' } }]"
            ></dxo-text-input>
          </div>
          <div class="row-input">
            <dxo-text-input
              [label]="'Password'"
              [maxlength]="80"
              formControlName="password"
              type="password"
              [dxoDataset]="[{ selector: 'input', data: { e2e: 'userlogin-password-input' } }]"
            ></dxo-text-input>
          </div>
        </div>
      </div>
      <div class="buttons">
        <dxo-button 
          smallButton
          text="Log in" 
          (handleClick)="onSubmit()" 
          [primary]="true"
          [disabled]="loginForm.invalid"
          [dxoDataset]="[{ selector: 'button', data: { e2e: 'demouserlogin-login-button' } }]"
        ></dxo-button>
      </div>      
      <dxo-modal *ngIf="showErrorModal" [title]="'Log In Error'" [shouldShowCloseX]="false">
        <modal-body>
          {{ errorMessage }} 
          <dxo-button class="close-button" [size]="'small'" [text]="'Close'" (handleClick)="modalClose()"></dxo-button>         
        </modal-body>
      </dxo-modal>
    </form>
  </div>
</div>
